<router-outlet></router-outlet>
<psei-dimmer dimmerId="content"></psei-dimmer>
<psei-drawer dimmerId="content" [outlet]="'drawer'"></psei-drawer>
<psei-dimmer class="dimmer-window" dimmerId="window"></psei-dimmer>

